export default __webpack_public_path__ + "static/media/Team04.0d19029c.jpg";